import React from 'react'
import './Seva_Banner.css'

const Seva_Banner = () => {
  return (
    <section className='Seva_Banner'>
        <div className='container'>
            <div className='banner_div'>
                <img src='/assets/images/seva_logbook/banner.png' className='banner_img'/>
            </div>
        </div>
    </section>
  )
}

export default Seva_Banner
